import React, { useState } from 'react'
import Axios from 'axios'
import Snackbar from '@material-ui/core/Snackbar'
import MuiAlert from '@material-ui/lab/Alert'
import { split } from 'lodash'
import MuiPhoneInput from 'material-ui-phone-number'
import { Controller, useFormContext } from 'react-hook-form'
import { CircularProgress, Typography, TextField, Grid } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack'

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const PhoneNumber = (props) => {
  const { t } = useTranslation('translations')
  const { labelHidden, phoneVerification, numberDisabled, phoneInputName = 'tenant_phone_no' } = props
  const { control, errors, watch, register } = useFormContext()
  const values = watch()
  const [verified, setVerified] = useState(false)
  const { enqueueSnackbar } = useSnackbar()
  const [notification, setNotification] = useState(false)
  const [loadingValidate, setLoadingValidate] = useState(false)
  const handleOnClickValidate = async () => {
    if (!!values && !!values.tenant_phone_no) {
      setLoadingValidate(true)
      try {
        const { data: res } = await Axios.post(`${process.env.REACT_APP_API}/user/sendmobilecode`, {
          phone_no: values.tenant_phone_no,
          country_code: split(values.tenant_phone_no, ' ')[0]
        })
        enqueueSnackbar(t('number.sentMessage'), { variant: 'success' })
        setVerified(true)
        setLoadingValidate(false)
      } catch (e) {
        setLoadingValidate(false)
        enqueueSnackbar(t(`number.phoneInvalid`))
      }
    }
  }
  const handleClose = () => setNotification(false)
  return (
    <>
      <Grid item xs={12} lg={10}>
        {!labelHidden && <Typography variant='body1'>{t('number.phone')}</Typography>}
        <Controller
          name={phoneInputName}
          control={control}
          render={(props) => (
            <div className='w-full flex flex-row items-center justify-between'>
              <div className={phoneVerification ? 'w-9/12' : 'w-full'}>
                {numberDisabled ? (
                  <>
                    <TextField
                      {...props}
                      fullWidth
                      error={errors[phoneInputName]}
                      variant='outlined'
                      disabled={numberDisabled}
                      name={phoneInputName}
                    />
                  </>
                ) : (
                    <MuiPhoneInput
                      {...props}
                      defaultCountry='it'
                      variant='outlined'
                      name={phoneInputName}
                      error={errors[phoneInputName]}
                      fullWidth
                      autocompleteSearch
                      disabled={numberDisabled}
                      disableDropdown={numberDisabled}
                      onChange={(value, data) => props.onChange(value)}
                      inputProps={{
                        name: phoneInputName,
                        disabled: numberDisabled
                      }}
                    />
                  )}
              </div>
              {phoneVerification && (
                <div className='w-3/12 text-center cursor-pointer'>
                  {loadingValidate && <CircularProgress color='primary' />}
                  {!loadingValidate && <Typography variant='body2' color='primary' onClick={handleOnClickValidate} >{t('number.validateNumber')}</Typography>}
                </div>
              )}
            </div>
          )}
        />
      </Grid>
      {
        verified && (
          <Grid item xs={12} lg={10}>
            {!labelHidden && <Typography variant='body1'>{t('number.code')}</Typography>}
            <Controller
              name='phone_verification_code'
              control={control}
              as={<TextField
                label={t('number.code')}
                fullWidth
                error={errors.phone_verification_code}
                variant='outlined'
              />}
            />
          </Grid>
        )
      }
    </>
  )
}

export default PhoneNumber